interface FranceNumLogoProps {
  size?: 'sm' | 'md' | 'lg';
  showMention?: boolean;
  className?: string;
}

export const FranceNumLogo = ({ 
  size = 'md', 
  showMention = false,
  className = '' 
}: FranceNumLogoProps) => {
  const sizeClasses = {
    sm: 'h-16',
    md: 'h-20',
    lg: 'h-24'
  };

  const logoContent = (
    <div className={`flex flex-col items-center gap-2 ${className}`}>
      <div className="bg-white rounded-lg p-3 shadow-sm border border-border/20">
        <img
          src="/images/activateur-france-num.png"
          alt="Logo Activateur France Num - NoCodeo est référencé Activateur France Num"
          className={`${sizeClasses[size]} w-auto object-contain`}
        />
      </div>
      {showMention && (
        <p className="text-xs text-muted-foreground text-center font-medium">
          Référencé Activateur France Num
        </p>
      )}
    </div>
  );

  return (
    <a
      href="https://www.francenum.gouv.fr/activateurs/nocodeo"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex transition-opacity hover:opacity-80"
      aria-label="En savoir plus sur les Activateurs France Num"
    >
      {logoContent}
    </a>
  );
};
